import { faCalendar, faHourglassEnd } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StringToDate from '../../../../util/StringToDate';
import { differenceInDays } from 'date-fns';
//Отобразит Дату начала/завершения задачи
function DateStartEndHistory({ date_start, date_end, date_completed }) {
    //date_start - Дата постановки задачи
    //date_end - Дата окончания действия задачи(до какой даты должна быть завершена задача)
    //date_completed - Фактическая дата завершения

    if (date_start !== null & date_end !== null) {

        const diff_days = differenceInDays(
            new Date(date_completed),
            new Date(date_end)
        )

        return (<>
            <FontAwesomeIcon icon={faCalendar} className='mr-10' />{StringToDate(date_start)} - {StringToDate(date_end)}
            {diff_days > 0 && <div className='text-danger'><b><FontAwesomeIcon icon={faHourglassEnd} className='mr-10' /> Просрочено {diff_days} дн.</b></div>}
        </>)
    }
    else if (date_start !== null & date_end === null) {
        return (<><FontAwesomeIcon icon={faCalendar} className='mr-10' />С {StringToDate(date_start)}</>)
    }
    else {
        return null;
    }
}
export default DateStartEndHistory;